import React, { useState } from 'react';
import {  View, Text, Pressable } from 'react-native';
import { commonStyles } from '../../common/style/common.style';

export default function BetWithoutAdditionnal(props) {

  const {
    selectedBetType,
    styles,
    selectedGrids,
    onNumberSelectChange,
    t,
  } = props;

  //====================================== Functions
  
  function computeNumberPickClass(grid, numb, gridIndex) {
    if (gridIndex % 2 !== 0 && selectedGrids[grid.gridName].selectedNumbers.includes(numb)) {
      return styles.oddPickNumberPressed;
    } else if (selectedGrids[grid.gridName].selectedNumbers.includes(numb)) {
      return styles.pickNumberPressed;
    } else {
      return styles.pickNumber;
    }
  }

  function computeNumberTextClass(grid, numb, gridIndex) {
    if (
      (gridIndex % 2 !== 0 && selectedGrids[grid.gridName].selectedNumbers.includes(numb))
      || selectedGrids[grid.gridName].selectedAdditionalNumbers.includes(numb)
      || selectedGrids[grid.gridName].selectedNumbers.includes(numb)) {
      return styles.numberPressed;
    } else {
      return styles.number;
    }
  }

  function isGridComplete(grid, gridIndex) {

    if(gridIndex === undefined) return;

    return selectedBetType?.listOfGridParameters[gridIndex].requiredNumber
      === selectedGrids[grid.gridName].selectedNumbers.length ?
      `${t('Grid Complete')}`
      :
      `${t('Select')} ${selectedBetType?.listOfGridParameters[gridIndex].requiredNumber - selectedGrids[grid.gridName].selectedNumbers.length} ${t('numbers')}`;
  }

  return (
    <View>
      {selectedBetType?.listOfGrids.map((grid, gridIndex) => {
        return (
          <View key={gridIndex}>
            <Text style={styles.stepTitle}>
                {isGridComplete(grid, gridIndex)}
            </Text>

            <View style={styles.grid}>
              {selectedBetType?.listOfGrids.length > 1 && 
                <Text style={styles.gridTitle}>
                  {grid.gridName}
                </Text>              
              }

              <View style={styles.gridPicker}>  
                {grid.listOfLottoNumbers.map((numb, index) => {
                  const [numberPress, setNumberPress] = useState(false);
                  return (
                    <Pressable
                      key={index}
                      onPress={() => {
                        setNumberPress(!numberPress);
                        onNumberSelectChange(numb, grid.gridName);
                      }}
                      style={({ pressed }) => {
                        return [computeNumberPickClass(grid, numb, gridIndex), !pressed && commonStyles.shadowedButton];                                                  
                      }}
                    >
                      <Text style={computeNumberTextClass(grid, numb, gridIndex)}>
                        {numb}
                      </Text>
                    </Pressable>
                  )
                })}
              </View>

            </View>
          </View>              
        )
      })}
    </View>
  );
}